import { useState } from "react";
import { api } from "../../../../../../../utility/api";

export const ContaminantesApi = () => {
    const [cargando, setCargando] = useState(false);

    const getContaminantes = async (params) => {
        return api
            .get("contaminante", params)
            .then((data) => {
                if (data) return data.results;
                return [];
            })
            .catch(() => {
                return [];
            });
    };

    return {
        getContaminantes,

        cargando,
    };
};
